module.exports = __webpack_public_path__ + "img/joinZigZag.74d4bfe1.svg";